import { stats } from "@/mocks/categories";

export default function TrustStats() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            Trusted by Buyers Worldwide
          </h2>
          <p className="text-foreground-600 text-base">
            The <strong>acbuyspreadsheet</strong> community keeps growing every day
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading text-primary-600 mb-2">
                {stat.value}
              </div>
              <p className="text-xs md:text-sm text-foreground-500 uppercase tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}